import React, { Component } from 'react';

class GraficoBarra extends Component {

    getPercentage(){
        var p = this.props.percentage || 0;
        p = Math.min(p, 100);
        p = Math.max(p,0);
        return p;
    }

    getIndicatorPercentage(){
        var p = this.props.indicatorPercentage || 0;
        p = Math.min(p, 100);
        p = Math.max(p,0);
        return p;
    }

    getStarPercentage(){
        var p = this.props.starPercentage || 0;
        p = Math.min(p, 100);
        p = Math.max(p,0);
        return p;
    }
    render() {
        return (
            <div className={this.props.className} style={{width: '100%', height:'24px', /*zIndex: '-1',*/ backgroundColor: '#EDEBEE', position:'relative', borderRadius:"2px"}}>
                {/* Barra do gráfico */}
                <div style={{
                        width: this.getPercentage()+'%',
                        height: "100%",
                        backgroundColor: "#3388bb",
                        borderRadius:"2px",
                        color: "white",
                        minWidth: "25px",
                        fontSize: "12px",
                        padding: "3px",
                        textAlign: "right"
                }}> </div>

                {/* Indicador da escola */}
                {this.getIndicatorPercentage() > 0 &&
                    <div style={{
                        position:'absolute',
                        top:'-2px',
                        height:'28px',
                        width:'4px',
                        marginLeft:'-2px',
                        backgroundColor:"#666666",
                        left: this.getIndicatorPercentage()+'%'
                        }}></div>
                }

                {/* Escola referencia (Estrela) */}
                {this.getStarPercentage() > 0 &&
                    <div style={{
                        position:'absolute',
                        top:'1px',
                        width: this.getStarPercentage()+'%',
                        height: "100%",
                        color:"#EEBB11",
                        minWidth: "25px",
                        textAlign: "right"
                    }}> <i className="fas fa-star"></i> </div>
                }

                <div style={{
                        position:'absolute',
                        top:'0',
                        width: this.getPercentage()+'%',
                        height: "100%",
                        color: "white",
                        textShadow: "0px 0px 2px #505050",
                        minWidth: "25px",
                        fontSize: "12px",
                        padding: "3px",
                        textAlign: "right"
                }}> {this.getPercentage()}% </div>
            </div>
        );
    }
}


export default GraficoBarra;